module.exports = __webpack_public_path__ + "static/media/logo-arrow.5791756e.png";